export const fileConstants = {
    DATAWRANGLER_FILE: 'DATAWRANGLER_FILE',
    VISUALIZER_FILE: 'VISUALIZER_FILE',
    UPDATE_DATA_WRANGLER_DATA_TABLE_CONFIG: 'UPDATE_DATA_WRANGLER_DATA_TABLE_CONFIG',
    UPDATE_DATA_WRANGLER_SUMMARY_CONFIG: 'UPDATE_DATA_WRANGLER_SUMMARY_CONFIG',
    UPDATE_DATA_VISUALIZER_CONFIG: 'UPDATE_DATA_VISUALIZER_CONFIG',
    UPDATE_DATA_VISUALIZER_MOCK_CONFIG: 'UPDATE_DATA_VISUALIZER_MOCK_CONFIG',
    UPDATE_DATA_VISUALIZER_PLOTLY_CONFIG: 'UPDATE_DATA_VISUALIZER_PLOTLY_CONFIG',
}
